
export default class ClipData {
    
    constructor(id = null, file = null, path = null, triggerTime = null) {
        this.id = id
        this.file = file
        this.path = path
        this.filePath = [path, file].join("")
        this.triggerTime = triggerTime
    }
}